// Copyright (c) 2020 Deere & Company

import * as fetchService from '../services/fetch';
import {getDefaultState as getDefaultsapStatusState} from '../state/sap-Status';

const basePath = '/api';

export const getSapStatus = async () => {

    const endPoint = `${basePath}/sap-status`;

    const options = {
        endpointId: 'sap-status'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (error) {

        const defaultResponse = getDefaultsapStatusState();

        return defaultResponse;

    }

};




// WEBPACK FOOTER //
// ./src/shared/repositories/sap-status.js